export default {
  bind(el, binding, vNode) {
    // 获取element-ui定义好的scroll盒子
    const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
    let oldHeight = 0;
    SELECTWRAP_DOM.addEventListener('scroll', function() {
      // TODO: 使用 parseInt 是因为 报表 中的下拉会出现 相减 的浮点数
      const CONDITION = parseInt(this.scrollHeight - this.scrollTop) <= this.clientHeight;
      // TODO: 监听滚动区域的高度变化，如果高度变小了则列表重置了，列表回到顶部
      if (this.scrollHeight < oldHeight) {
        this.scrollTop = 0;
        oldHeight = 0;
        return;
      }
      oldHeight = this.scrollHeight;
      if (CONDITION) {
        if (binding.arg) {
          // v-selectloadmore:filterBarSelectLoadMore="item"
          let that = vNode.context;
          that[binding.arg](binding.value);
        } else {
          // v-selectloadmore="loadmore"
          binding.value();
        }
      }
    });
  },
};
